import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {required, Text} from "components/form";
import {Number} from "shared/Number";

interface State extends DataBaseComponentState {
    seconds: number;
    message: string;
}

class TestEventMessageDialog extends DataBaseComponent<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = { seconds: 60, message: "Test Message" };
    }

    render() {
        return <SaveDialogLayout onSaveClick={() => this.save()} title={"Send Test Message"} errors={this.state.errors} busy={this.state.busy} saveButtonLabel={"Send"}>
            <Number label="Seconds to delay message success"
                    value={this.state.seconds}
                    min={0}
                    onChange={seconds => this.setState({seconds})}
            />
            <Text label="Message"
                  value={this.state.message}
                  onChange={message => this.setState({message})}
                  validate={required("Please enter a message")}
                  error={this.getFieldError("Message")}
                  autoFocus={true}
            />
        </SaveDialogLayout>;
    }

    private async save(): Promise<boolean> {
        return this.doBusyTask(async () => {
            await repository.MessageBus.testEventMessageWithDelay({ Message: this.state.message, Seconds: this.state.seconds });
        });
    }
}

export default TestEventMessageDialog;
